import { render, staticRenderFns } from "./form-create.vue?vue&type=template&id=3a46247c&scoped=true"
import script from "./form-create.vue?vue&type=script&lang=js"
export * from "./form-create.vue?vue&type=script&lang=js"
import style0 from "./form-create.vue?vue&type=style&index=0&id=3a46247c&prod&lang=css"
import style1 from "./form-create.vue?vue&type=style&index=1&id=3a46247c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a46247c",
  null
  
)

export default component.exports